<span class="reusable-button">
    <i class="fa fa-save mr-2"></i>
    <span>{{ 'Save' | translate }}</span>
</span>

